import apiClient from "@/services/apiClient";

export default {
    data() {
        return {
            ordersApiUrl: process.env.VUE_APP_ORDERS_API_URL
        }
    },
    methods: {
        async getCustomers(params) {
          const qs = new URLSearchParams(params);
          const {data} = await apiClient.get(`${this.ordersApiUrl}/customers/search?${qs}`);
          return data;
        },
        async updateCustomer(customerId, data) {
            return await apiClient.put(`${this.ordersApiUrl}/customers/admin/${customerId}`, data);
        },
        async getCustomerOrders(customerId) {
          const { data } = await apiClient.get(`${this.ordersApiUrl}/customers/orders/${customerId}`);
          return data;
        },
        async getInventoryOrderedByCustomerId(customerId) {
          const { data } = await apiClient.get(`${this.ordersApiUrl}/customers/listings-ordered/${customerId}`);
          return data;
        },
        async getCustomerWantlist(customerId) {
          const {data} = await apiClient.get(`${this.ordersApiUrl}/customers/wantList/${customerId}`);
          return data;
        },
        async addWants(wantListId = null, itemIds = [], email = null ) {
          const payload = { wantListId: wantListId, itemIds: itemIds, email: email } || {};
          const { data } = await apiClient.put(`${this.ordersApiUrl}/customers/admin/addWants/`, payload);
          return data;
        },
        async removeWants(wantListId, itemIds) {
          const payload = { itemIds: itemIds } || {};
          const { data } = await apiClient.put(`${this.ordersApiUrl}/customers/admin/removeWants/${wantListId}`, payload);
          return data;
        }, 
        async createCustomer(customer) {
          const { data } = await apiClient.post(`${this.ordersApiUrl}/customers`, customer);
          return data;
        }
    }
};